import { motion } from "framer-motion";
import { useLanguage } from "@/contexts/LanguageContext";
import {
  ShieldCheck,
  BrainCircuit,
  User,
  MapPin,
  MessageCircle,
  Sparkles,
} from "lucide-react";

const ICONS = [ShieldCheck, BrainCircuit, User, MapPin, MessageCircle, Sparkles];

const WhyChooseUs = () => {
  const { t } = useLanguage();
  const items = [1, 2, 3, 4, 5, 6].map((n, i) => ({
    Icon: ICONS[i],
    title: t(`why.r${n}.title`),
    desc: t(`why.r${n}.desc`),
  }));

  return (
    <section
      id="why"
      data-testid="why-section"
      className="container-px mx-auto max-w-7xl py-24 lg:py-32"
    >
      <div className="max-w-2xl">
        <p className="text-xs uppercase tracking-[0.22em] text-sky-700 font-medium">
          {t("why.eyebrow")}
        </p>
        <h2 className="font-display mt-3 text-4xl lg:text-6xl font-light tracking-tighter text-neutral-950 text-balance">
          {t("why.title")}
        </h2>
      </div>

      <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 lg:gap-5">
        {items.map((it, i) => (
          <motion.div
            key={i}
            initial={{ opacity: 0, y: 14 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.45, delay: i * 0.05 }}
            className="group rounded-3xl bg-white border border-neutral-200 p-7 hover:border-neutral-300 hover:shadow-[0_10px_30px_rgba(0,0,0,0.05)] transition-all"
            data-testid={`why-card-${i}`}
          >
            <div className="w-11 h-11 rounded-2xl bg-sky-50 text-sky-700 grid place-items-center border border-sky-100 group-hover:bg-neutral-950 group-hover:text-white transition-colors">
              <it.Icon className="w-5 h-5" />
            </div>
            <h3 className="font-display mt-5 text-xl font-medium text-neutral-950">
              {it.title}
            </h3>
            <p className="mt-2 text-neutral-600 text-[15px] leading-relaxed">
              {it.desc}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};

export default WhyChooseUs;
